// Generated by purs version 0.15.15
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var encodeJSON = /* #__PURE__ */ Foreign_Generic.encodeJSON(Foreign_Generic_Class.foreignEncode);
var Serialized = function (x) {
    return x;
};
var showSerialized = {
    show: function (v) {
        return encodeJSON(v);
    }
};
var serialize = function (dictEncode) {
    var encode = Foreign_Generic_Class.encode(dictEncode);
    return function (x) {
        return encode(x);
    };
};
var deserialize = function (dictDecode) {
    var unsafeDecode = Unscramble.unsafeDecode(dictDecode);
    return function (v) {
        return unsafeDecode(v);
    };
};
export {
    serialize,
    deserialize,
    showSerialized
};
